import {
  CreateAccountPayload,
  CreateAccount,
  PackageDetail,
} from './interfaces';
import { useFetch, usePut } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useCreateAccountRequest = (formData: object, token: string) =>
  usePut<CreateAccountPayload, CreateAccount>(
    apiEndpoints.createAccountUrl.replace(':token', token)
  );
export const usePackageDetailRequest = (hash: string) => {
  const url = apiEndpoints.packageDetail.replace(':hash', hash);
  return useFetch<PackageDetail>(url);
};

export * from './interfaces';
export * from './schemas';
